const styles = theme => ({
    alertPanel: {
        width: '100%',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    caption: {
        color: theme.palette.text.primary,
        fontWeight: 600
    },
    captionPanel:{
        marginBottom: theme.spacing(1) 
    }
});

export default styles;